<template>
  <el-dialog :append-to-body="true" :before-close="close" :close-on-click-modal="false" :visible.sync="dialog" title="修改邮箱" width="400px">
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="邮箱">
        </el-input>
      </el-form-item>

      <el-form-item label="验证码" prop="code">
        <el-row>
          <el-col :span="12">
            <el-input v-model="form.code" placeholder="验证码">
            </el-input>
          </el-col>
          <el-col :offset="2" :span="10">
            <el-button :disabled="codeButtonStatus.status" plain style="width:100%" type="primary" @click="getSms(form.email)">
              {{ codeButtonStatus.text }}
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" style="width:100%" type="primary" @click="changeEmail">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {change_email, getSms} from '@/api'
import {validEmail} from '@/utils/validate'

export default {
  data() {
    return {
      dialog: false,
      form: {
        email: '',
        code: '',
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      loading: false,
      timer: null,
      codeButtonStatus: {
        status: false,
        text: '获取验证码',
      },
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.form = {
        email: '',
        code: '',
      }
      this.dialog = false
    },
    updateButtonStatus(params) {
      this.codeButtonStatus.status = params.status;
      this.codeButtonStatus.text = params.text;
    },
    countDown(number) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      let time = number;
      this.timer = setInterval(() => {
        time--;
        this.codeButtonStatus.text = `${time}秒`;
        if (time === 0) {
          clearInterval(this.timer);
          this.updateButtonStatus({
            status: false,
            text: '获取验证码',
          });
        }
      }, 1000);
    },
    clearCountDown() {
      this.updateButtonStatus({
        status: false,
        text: '获取验证码',
      });
      clearInterval(this.timer);
    },
    getSms(phone) {
      if (!phone) {
        this.$message.error('请输入邮箱');
        return;
      }
      if (!validEmail(phone)) {
        this.$message.error("邮箱格式不正确");
        return;
      }
      this.updateButtonStatus({
        status: true,
        text: "发送中",
      });
      let req = {
        email: phone,
      }
      getSms(req).then(res => {
        this.$message.success(res.msg || '发送成功')
        this.countDown(60);
      }).catch(err => {
        this.clearCountDown()
      })
    },
    changeEmail() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let req = {
            email: this.form.email,
            email_code: this.form.code,
          }
          change_email(req).then(res => {
            this.loading = false
            this.$message.success(res.msg)
            this.close()
          }).catch(err => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
